import React from 'react';
import ChatMessage from './ChatMessage';
import { ConversationMessage } from '../goFormz-agent-types';
type ChatMessagesProps = {
  sessionId: string;
  messages: ConversationMessage[];
  formulaSelected?: (formula: string) => void;
};

export default function ChatMessages({ sessionId, messages, formulaSelected }: ChatMessagesProps) {
  if (messages.length === 0) {
    return (
      <div className="empty-message-container">
        <div className="empty-messages-text">
          Hello! I'm GoPilot —an automated virtual helper here to answer your questions. Please note that my responses are generated by AI and may not always be
          perfectly accurate. Always verify any critical information, and avoid sharing confidential or sensitive data.
        </div>
      </div>
    );
  }

  return (
    <>
      {messages.map((message, index) => (
        <ChatMessage sessionId={sessionId} key={index} message={message} formulaSelected={formulaSelected} />
      ))}
    </>
  );
}
